import styled from 'styled-components';
import { CssSpace } from '@xbcb/ui-types';

export const StyledUnitAssistInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${CssSpace.SPACE_2};
  justify-content: flex-end;
`;

export const StyledUnitAssistInputMinusButtonWrapperDiv = styled.div`
  display: inline-block;
  margin-left: calc(${CssSpace.SPACE_3} * -1);
  margin-right: ${CssSpace.SPACE_4};
  margin-top: -${CssSpace.SPACE_6};
  align-self: flex-start;
`;
